module.exports = __webpack_public_path__ + "static/media/tyres_ao.9ce29e81.jpg";